/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 * This barrel eagerly parses the full translation catalogue (translations/
 * en.json) and configures moment's locale — that is what the app boot path
 * wants, but it makes the barrel expensive to import. Consumers that only
 * need part of it should import the split modules directly:
 *
 *   - `core/i18n/constants` — DEFAULT_LOCALE / DEFAULT_FULL_LOCALE / appLocales
 *   - `core/i18n/intl`      — the imperative intl singleton (generateIntl, intl)
 *   - `core/i18n/messages`  — the translation catalogue (lazy-load with
 *                             `import()` outside the app boot path)
 */
import moment from 'moment'

import { DEFAULT_FULL_LOCALE } from './constants'

export * from './constants'
export * from './intl'
export * from './messages'

moment.locale(DEFAULT_FULL_LOCALE)
